/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AccountOnboardSummary { 
    /**
     * Number of requests failed to onboard accounts.
     */
    failure: number;
    /**
     * Number of accounts successfully onboarded.
     */
    success: number;
    /**
     * Total number of accounts received for onboarding.
     */
    total: number;
}

